<template>
    <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <title/>
        <path d="M54,42H42a6,6,0,0,1,0-12H66a6,6,0,0,0,0-12H54V12a6,6,0,0,0-12,0v6a18,18,0,0,0,0,36H54a6,6,0,0,1,0,12H30a6,6,0,0,0,0,12H42v6a6,6,0,0,0,12,0V78a18,18,0,0,0,0-36Z"/>
    </svg>
</template>
